module.exports = __webpack_public_path__ + "img/stop_timer.9758552d.svg";